import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import localePy from '@angular/common/locales/es-PY';
import {registerLocaleData} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './components/auth/login/login.component';
import {LayoutComponent} from './components/layout/layout.component';
import {AsideComponent} from './components/layout/aside/aside.component';
import {FooterComponent} from './components/layout/footer/footer.component';
import {HeaderComponent} from './components/layout/header/header.component';
import {MessageComponent} from './components/message/message.component';
import {HomeComponent} from './components/home/home.component';
import {SplashScreenComponent} from './components/splash-screen/splash-screen.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {JwtAuthInterceptor} from './interceptors/jwt-auth.interceptor';
import {ErrorAuthInterceptor} from './interceptors/error-auth.interceptor';
import {NgxSpinnerModule} from 'ngx-spinner';
import {DataTablesModule} from 'angular-datatables';
import {NgSelect2Module} from 'ng-select2';
import {MerchantsComponent} from './components/merchants/merchants.component';
import {CategoriesComponent} from './components/categories/categories.component';
import {CategoryAddEditComponent} from './components/categories/category-add-edit/category-add-edit.component';
import {ToastrModule} from 'ngx-toastr';
import {MerchantAddEditComponent} from './components/merchants/merchant-add-edit/merchant-add-edit.component';
import {OnlyIntNumberDirective} from './directives/only-int-number.directive';
import {ProductsComponent} from './components/products/products.component';
import {OnlyNumberDirective} from './directives/only-number.directive';
import {ProductAddEditComponent} from './components/products/product-add-edit/product-add-edit.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {TagInputModule} from 'ngx-chips';
import {OrdersComponent} from './components/orders/orders.component';
import {BankAccountsComponent} from './components/bank-accounts/bank-accounts.component';
import {BankAccountAddEditComponent} from './components/bank-accounts/bank-account-add-edit/bank-account-add-edit.component';
import {OrderDetailModalComponent} from './components/orders/order-detail-modal/order-detail-modal.component';
import { CustomersComponent } from './components/customers/customers.component';
import { BrandsComponent } from './components/brands/brands.component';
import { BrandAddEditComponent } from './components/brands/brand-add-edit/brand-add-edit.component';
import { BrandTypeProductsComponent } from './components/brand-type-products/brand-type-products.component';
import { BrandTypeProductAddEditComponent } from './components/brand-type-products/brand-type-product-add-edit/brand-type-product-add-edit.component';
import { BrandSubTypeProductsComponent } from './components/brand-sub-type-products/brand-sub-type-products.component';
import { BrandSubTypeProductAddEditComponent } from './components/brand-sub-type-products/brand-sub-type-product-add-edit/brand-sub-type-product-add-edit.component';
import { BannersComponent } from './components/banners/banners.component';
import { BannersAddEditComponent } from './components/banners/banners-add-edit/banners-add-edit.component';
import { ConfirmOrderModalComponent } from './components/orders/confirm-order-modal/confirm-order-modal.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { CouponsComponent } from './components/coupons/coupons.component';
import { AddEditCouponsComponent } from './components/coupons/add-edit-coupons/add-edit-coupons.component';

registerLocaleData(localePy, 'es');

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        LayoutComponent,
        AsideComponent,
        FooterComponent,
        HeaderComponent,
        MessageComponent,
        HomeComponent,
        SplashScreenComponent,
        MerchantsComponent,
        CategoriesComponent,
        CategoryAddEditComponent,
        MerchantAddEditComponent,
        OnlyIntNumberDirective,
        ProductsComponent,
        OnlyNumberDirective,
        ProductAddEditComponent,
        OrdersComponent,
        BankAccountsComponent,
        BankAccountAddEditComponent,
        OrderDetailModalComponent,
        CustomersComponent,
        BrandsComponent,
        BrandAddEditComponent,
        BrandTypeProductsComponent,
        BrandTypeProductAddEditComponent,
        BrandSubTypeProductsComponent,
        BrandSubTypeProductAddEditComponent,
        BannersComponent,
        BannersAddEditComponent,
        ConfirmOrderModalComponent,
        SubscriptionsComponent,
        CouponsComponent,
        AddEditCouponsComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        BrowserAnimationsModule,
        DataTablesModule,
        NgSelect2Module,
        ToastrModule.forRoot(),
        CKEditorModule,
        TagInputModule
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'es-PY'},
        {provide: HTTP_INTERCEPTORS, useClass: JwtAuthInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorAuthInterceptor, multi: true},
    ],
    entryComponents: [
        OrderDetailModalComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
